<template>
    <span class="tier-icon" v-if="svgSource || tier.iconEmoji" aria-hidden="true">
        <img v-if="svgSource" :src="svgSource" alt="" />
        <template v-else>{{ tier.iconEmoji }}</template>
    </span>
</template>

<script>
export default {
    name: "TierIcon",
    props: {
        tier: {
            type: Object,
            required: true,
        },
    },
    computed: {
        svgSource() {
            if (this.tier.iconType !== "svg" || !this.tier.iconSvg) {
                return "";
            }

            return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(this.tier.iconSvg);
        },
    },
};
</script>

<style lang="scss">
.tier-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  line-height: 1;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
